import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { LedgerRow } from '../../../Table/LedgerTable'
import { styles } from './licensingBillingPdfStyles'

export const BreakdownForPDF: React.FC<{
  breakdownRows: LedgerRow[]
  headerLabel?: string
  subHeaderRowCssProps?: React.CSSProperties
  subHeaderCellCssProps?: React.CSSProperties
  bodyCellCssProps?: React.CSSProperties
}> = ({
  breakdownRows,
  headerLabel,
  subHeaderRowCssProps,
  subHeaderCellCssProps,
  bodyCellCssProps,
}) => {
  return (
    <>
      {!!headerLabel && (
        <TableRow
          style={{
            ...styles.tableBodyCell,
            padding: 0,
            ...(subHeaderRowCssProps || {}),
          }}
        >
          <TableCell
            style={{
              ...styles.tableSubHeaderCell,
              ...(subHeaderCellCssProps || {}),
            }}
          >
            {headerLabel}
          </TableCell>
        </TableRow>
      )}
      {breakdownRows.map(({ cells }, rowIndex) => (
        <TableRow key={rowIndex}>
          {cells.map(
            (
              {
                content,
                align,
                color = 'medium',
                cssTextProps,
                colSpan,
                cellCssProps,
              },
              index
            ) => {
              return (
                <TableCell
                  style={{
                    ...styles.tableBodyCell,
                    textAlign: align,
                    color,
                    ...(cssTextProps && { ...cssTextProps }),
                  }}
                  sx={{
                    ...(bodyCellCssProps || {}),
                    ...(cellCssProps || {}),
                  }}
                  colSpan={colSpan}
                  key={index}
                >
                  {content}
                </TableCell>
              )
            }
          )}
        </TableRow>
      ))}
    </>
  )
}
